import React, { useState } from "react";

import { APIEndpoints } from "../constants/APIEndpoints";
import BaseClientNew from "../helper/BaseclientNew";

const useEvents = () => {
  const [eventsList, setEventsList] = useState(null);
  const [eventsLoading, setEventsLoading] = useState(false);

  const getEvents = async (token) => {
    try {
      setEventsLoading(true);

      await BaseClientNew.get(APIEndpoints.fetchAllEvents, {
        onSuccess: (res) => {
          if (res?.data) {
            setEventsList(res.data);
          }
        },
        onFailed: (err) => {
          console.log("Error is on fetching EVENTS");
        },
      });
    } finally {
      setEventsLoading(false);
    }
  };

  const createNewEvents = async (payload, { onSuccess, onFailed }) => {
    try {
      setEventsLoading(true);

      await BaseClientNew.post(APIEndpoints.createEvent, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setEventsLoading(false);
    }
  };

  const updateSingleEvent = async (payload, { onSuccess, onFailed }) => {
    try {
      setEventsList(true);

      await BaseClientNew.put(APIEndpoints.updateEvent, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setEventsList(false);
    }
  };

  return {
    eventsList,
    eventsLoading,
    getEvents,
    createNewEvents,
    updateSingleEvent
  };
};

export default useEvents;
